import { EmptyState } from '@workspace/ui/components/empty-state'
import { LoadingSpinner } from '@workspace/ui/components/loading-spinner'
import { ToastProvider } from '@workspace/ui/components/toast'
import type { ReactNode } from 'react'
import { InvestorLayout } from '../../../components/investor-layout'
import { useMcpSettingsQuery } from '../hooks/use-investor-assistant'

/** The assistant screens exist only while the feature is open; until then they say so instead of working. */
export function AssistantGate({
  activeNav,
  sidePanel,
  children,
}: {
  activeNav: string
  /** A panel beside the page (the startup panel); only shown once the assistant is open. */
  sidePanel?: ReactNode
  children: ReactNode
}) {
  const { data, isLoading, error } = useMcpSettingsQuery()

  if (isLoading) {
    return (
      <InvestorLayout activeNav={activeNav}>
        <div className="flex h-64 items-center justify-center">
          <LoadingSpinner />
        </div>
      </InvestorLayout>
    )
  }
  if (error || !data?.data) {
    return (
      <InvestorLayout activeNav={activeNav}>
        <EmptyState title="Could not load this page" description="Try again in a moment." />
      </InvestorLayout>
    )
  }
  if (!data.data.assistantEnabled) {
    return (
      <InvestorLayout activeNav={activeNav}>
        <EmptyState
          title="Not open yet"
          description="AI assistant access is not open on your account yet."
        />
      </InvestorLayout>
    )
  }
  return (
    <ToastProvider>
      <InvestorLayout activeNav={activeNav} sidePanel={sidePanel}>
        {children}
      </InvestorLayout>
    </ToastProvider>
  )
}
